import { skipToken, useQuery } from "@tanstack/react-query"
import { utilityKeys } from "./queryKeys"
import { getUtility, getUtilityBillCycles } from "./utilities"

export const useGetUtilityQuery = (utility_code: string | undefined) => {
  return useQuery({
    queryKey: utilityKeys.detail(utility_code),
    queryFn: utility_code ? () => getUtility(utility_code) : skipToken,
  })
}

export const useGetUtilityBillCyclesQuery = (
  utility_code: string | undefined,
) => {
  return useQuery({
    queryKey: utilityKeys.billCycles(utility_code),
    queryFn: utility_code
      ? () => getUtilityBillCycles(utility_code)
      : skipToken,
  })
}
